<template>
  <el-dialog
    :title="`项目报名 - ${projectTitle}`"
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    width="600px"
    center
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <!-- 实名认证检查弹窗 -->
    <el-dialog
      title="实名认证提醒"
      :visible="authReminderVisible"
      @update:visible="authReminderVisible = $event"
      width="400px"
      center
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="auth-reminder-content">
        <div class="auth-icon">
          <i class="el-icon-warning" style="font-size: 48px; color: #e6a23c;"></i>
        </div>
        <div class="auth-text">
          <p>报名前需要完成实名认证</p>
          <p>是否现在去实名认证？</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="authReminderVisible = false">取消</el-button>
        <el-button type="primary" @click="goToAuthentication">去认证</el-button>
      </span>
    </el-dialog>
    
    <el-form :model="signupForm" :rules="signupRules" ref="signupFormRef" label-width="100px">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="signupForm.name" placeholder="请输入您的姓名"></el-input>
      </el-form-item>
      <el-form-item label="电话" prop="phone">
        <el-input v-model="signupForm.phone" disabled placeholder="请输入您的手机号码"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="idCard">
        <el-input v-model="signupForm.idCard" disabled placeholder="暂无实名认证信息"></el-input>
      </el-form-item>
<!--      <el-form-item label="上传材料" prop="uploadFiles">-->
<!--        <el-upload-->
<!--          ref="uploadRef"-->
<!--          :auto-upload="false"-->
<!--          :file-list="fileList"-->
<!--          :on-change="handleFileChange"-->
<!--          :on-remove="handleFileRemove"-->
<!--          :before-upload="beforeUpload"-->
<!--          accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"-->
<!--          action="#"-->
<!--        >-->
<!--          <el-button size="small" type="primary">点击上传</el-button>-->
<!--          <div slot="tip" class="el-upload__tip">-->
<!--            支持上传PDF、Word、JPG、PNG格式文件，单文件不超过5MB-->
<!--          </div>-->
<!--        </el-upload>-->
<!--      </el-form-item>-->
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="signupForm.remark"
          type="textarea"
          placeholder="请输入备注信息（可选）"
          :rows="3"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="submitting" @click="handleCancel">取消</el-button>
      <el-button :loading="submitting" type="primary" @click="handleSubmit">我要报名</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SignupDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    submitting: {
      type: Boolean,
      default: false
    },
    projectTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'isRealNameVerified', 'userInfo'])
  },
  watch: {
    visible(val) {
      if (val && this.userInfo) {
        this.signupForm.phone = this.userInfo.phone || ''
        this.signupForm.idCard = this.userInfo.idCard || ''
      }
    }
  },
  data() {
    const validateUploadFiles = (rule, value, callback) => {
      const count = Array.isArray(this.fileList) ? this.fileList.length : 0
      if (count <= 0) {
        callback(new Error('请上传报名材料'))
        return
      }
      callback()
    }
    return {
      // 实名认证提醒弹窗
      authReminderVisible: false,
      // 表单数据
      signupForm: {
        name: '',
        idCard: '',
        phone: '',
        email: '',
        education: '',
        uploadFiles: [],
        remark: ''
      },
      signupRules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '姓名长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        idCard: [],
        phone: [
          { required: true, message: '请输入您的手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入您的邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        education: [
          { required: true, message: '请选择您的学历', trigger: 'change' }
        ],
        uploadFiles: [
          { validator: validateUploadFiles, trigger: 'change' }
        ]
      },
      // 文件上传列表
      fileList: []
    }
  },
  methods: {
    // 取消报名
    handleCancel() {
      if (this.submitting) return
      this.$refs.signupFormRef.resetFields()
      this.$emit('update:visible', false)
      this.$emit('cancel')
      // 重置文件列表
      this.fileList = []
    },
    // 提交报名
    handleSubmit() {
      if (this.submitting) return
      // 检查是否已实名认证
      if (!this.isLoggedIn || !this.isRealNameVerified) {
        // 显示实名认证提醒
        this.authReminderVisible = true
        return
      }
      
      this.$refs.signupFormRef.validate((valid) => {
        if (valid) {
          const submitData = {
            ...this.signupForm,
            uploadFiles: (this.fileList || []).map(f => f && f.raw).filter(Boolean)
          }
          // 表单验证通过，提交报名信息
          this.$emit('submit', submitData)
        } else {
          // 表单验证失败
          this.$message.error('请填写正确的报名信息')
          return false
        }
      })
    },
    reset() {
      if (this.$refs.signupFormRef) {
        this.$refs.signupFormRef.resetFields()
      }
      this.fileList = []
    },
    // 文件上传前的校验
    beforeUpload(file) {
      const fileSize = file.size / 1024 / 1024
      if (fileSize > 5) {
        this.$message.error('单文件大小不能超过5MB')
        return false
      }
      return true
    },
    // 文件变化时的处理
    handleFileChange(file, fileList) {
      this.fileList = fileList
      // 更新表单的上传文件字段
      this.signupForm.uploadFiles = fileList
      if (this.$refs.signupFormRef) {
        this.$refs.signupFormRef.validateField('uploadFiles')
      }
    },
    // 文件移除时的处理
    handleFileRemove(file, fileList) {
      this.fileList = fileList
      // 更新表单的上传文件字段
      this.signupForm.uploadFiles = fileList
      if (this.$refs.signupFormRef) {
        this.$refs.signupFormRef.validateField('uploadFiles')
      }
    },
    // 去实名认证
    goToAuthentication() {
      // 关闭认证提醒弹窗
      this.authReminderVisible = false
      this.$emit('update:visible', false)
      this.$router.push('/member-center/settings').catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
}
</style>
